<template>
  <CustomFormsDatatable v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import CustomFormsDatatable from "@/CustomForms/CustomFormsDatatable.vue";

interface InitialData {
  source: string;
  filters: any[];
}

const initialData = ref<InitialData | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
